import { render, staticRenderFns } from "./ModalGiftBoxUpdate.vue?vue&type=template&id=d63cc474&scoped=true&"
import script from "./ModalGiftBoxUpdate.vue?vue&type=script&lang=js&"
export * from "./ModalGiftBoxUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ModalGiftBoxUpdate.vue?vue&type=style&index=0&id=d63cc474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63cc474",
  null
  
)

export default component.exports